import { styled } from '@mui/material';

import {
  CompleteIcon,
  OpenIcon,
  StarBorderSmallIcon,
  ThumbsDownIcon,
  ThumbsUpIcon,
} from '@app-velocity/icons';
import { Box } from '@app-velocity/ui';
import { useI18n } from '@app-velocity/i18n';

import { useScenarioDetailsContext } from '../../hooks/useScenarioDetailsContext';

const StyledStatistics = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  svg: {
    fill: 'var(--icon-icon-secondary-color)',
  },
}));

const SingleStatistic = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  color: 'var(--text-text-color-primary)',
  background: 'var(--background-background-secondary-color)',
  borderRadius: theme.spacing(2),
  padding: theme.spacing(2.5),
}));

const StatValue = styled('span')({
  fontWeight: 700,
  fontSize: 12,
});

const StatLabel = styled('span')({
  fontWeight: 400,
  fontSize: 12,
  color: 'var(--text-text-color-secondary)',
});

export const Statistics = () => {
  const { t } = useI18n();
  const { scenario } = useScenarioDetailsContext();

  if (!scenario || !scenario.statistic) return null;

  const { statistic } = scenario;

  const {
    openingCount,
    completionPercentage,
    averageRating,
    runsCount,
    totalDownvotes,
    totalUpvotes,
  } = statistic;

  if (!openingCount && !runsCount) return null;

  return (
    <StyledStatistics>
      <SingleStatistic>
        <OpenIcon />
        <StatValue>
          {openingCount}
        </StatValue>
        <StatLabel>{t('prototypes:times_opened')}</StatLabel>
      </SingleStatistic>
      <SingleStatistic>
        <CompleteIcon />
        <StatValue>{completionPercentage}%</StatValue>
        <StatLabel>{t('prototypes:completion')}</StatLabel>
      </SingleStatistic>

    {/* average rating for backwards compability */}
      {!averageRating || totalUpvotes || totalDownvotes ? (
        <>
          <SingleStatistic>
            <ThumbsUpIcon />
            <StatValue>{totalUpvotes}</StatValue>
            <StatLabel>{t('prototypes:rating')}</StatLabel>
          </SingleStatistic>
          <SingleStatistic>
            <ThumbsDownIcon />
            <StatValue>{totalDownvotes}</StatValue>
            <StatLabel>{t('prototypes:rating')}</StatLabel>
          </SingleStatistic>
        </>
      ) : (
        <SingleStatistic>
          <StarBorderSmallIcon />
          <StatValue>{(averageRating || 0).toFixed(1)}</StatValue>
          <StatLabel>{t('prototypes:avg_rating')}</StatLabel>
        </SingleStatistic>
      )}
    </StyledStatistics>
  );
};
